import React from 'react';
import { Popover as MuiPopover } from '@mui/material';

const Popover = (props) => {
  const { open, anchorEl, onClose, anchorOrigin, children } = props;

  return (
    <MuiPopover open={open} anchorEl={anchorEl} onClose={onClose} anchorOrigin={anchorOrigin}>
      {children}
    </MuiPopover>
  );
};

export default Popover;
